<template>
  <div class="row">
    <div class="col-12 p-0">
      <!-- سطر اول : نوع دفتر + سازمان -->
      <div
        class="row mb-3 p-0 d-flex justify-content-between align-items-center"
        id="HeadSpSelectBalance"
      >
        <!-- نوع دفتر -->
        <div class="col border rounded position-relative p-2">
          <div
            class="position-absolute"
            style="top: -10px; right: 10px; background: white; padding: 0 10px"
          >
            نوع دفتر
          </div>
          <div class="row">
            <div
              class="col p-1 text-right form-check d-flex align-items-center"
            >
              <input
                class="form-check-input"
                type="radio"
                value="3"
                v-model="SpSelectBalanceSendValues.DaftarType"
                name="RadioDaftar"
                id="Daftar_Koll"
                checked="checked"
              />
              <label class="form-check-label mr-3 pt-1" for="Daftar_Koll"
                >کل</label
              >
            </div>
            <div
              class="col p-1 text-right form-check d-flex align-items-center"
            >
              <input
                class="form-check-input"
                type="radio"
                value="5"
                v-model="SpSelectBalanceSendValues.DaftarType"
                name="RadioDaftar"
                id="Daftar_Moein1"
              />
              <label class="form-check-label mr-3 pt-1" for="Daftar_Moein1"
                >معین 1</label
              >
            </div>
            <div
              class="col p-1 text-right form-check d-flex align-items-center"
            >
              <input
                class="form-check-input"
                type="radio"
                value="7"
                v-model="SpSelectBalanceSendValues.DaftarType"
                name="RadioDaftar"
                id="Daftar_Moein2"
              />
              <label class="form-check-label mr-3 pt-1" for="Daftar_Moein2"
                >معین 2</label
              >
            </div>
            <div
              class="col p-1 text-right form-check d-flex align-items-center"
            >
              <input
                class="form-check-input"
                type="radio"
                value="11"
                v-model="SpSelectBalanceSendValues.DaftarType"
                name="RadioDaftar"
                id="Daftar_Tafsili"
              />
              <label class="form-check-label mr-3 pt-1" for="Daftar_Tafsili"
                >تفصیلی</label
              >
            </div>
            <div
              class="col-4 p-1 text-right form-check d-flex align-items-center"
            >
              <input
                class="form-check-input"
                type="checkbox"
                v-model="SpSelectBalanceSendValues.ConditionType"
                id="Daftar_All"
              />
              <label class="form-check-label mr-3 pt-1" for="Daftar_All"
                >فقط سطح مشخص شده</label
              >
            </div>
          </div>
        </div>
        <!-- سازمان -->
        <div class="col border rounded position-relative p-2 mr-1">
          <div
            class="position-absolute"
            style="top: -10px; right: 10px; background: white; padding: 0 10px"
          >
            سازمان
          </div>
          <div class="row">
            <div
              class="col d-flex justify-content-start align-items-center p-0"
            >
              <div class="input-group">
                <select
                  class="form-control form-control-sm rounded-0"
                  v-bind:disabled="getTbBaseOrgData.length == 1"
                  v-model="SpSelectBalanceSendValues.Organization"
                >
                  <option
                    v-for="option in getTbBaseOrgData"
                    v-bind:key="option.NCode"
                    v-bind:value="option.NCode"
                  >
                    {{ option.SDesc }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <!-- فضای خالی -->
        <div class="col-1 mr-1"></div>
      </div>

      <!-- سطر دوم : شروط محاسبه + شروط نمایش -->
      <div
        class="row mb-3 p-0 d-flex justify-content-between align-items-center"
      >
        <!-- شروط نمایش حساب ها -->
        <div class="col border rounded position-relative p-2">
          <div
            class="position-absolute"
            style="top: -10px; right: 10px; background: white; padding: 0 10px"
          >
            شروط نمایش حساب‌ها
          </div>
          <div class="row">
            <div
              class="col p-1 text-right form-check d-flex align-items-center"
            >
              <input
                class="form-check-input"
                type="radio"
                value="AllHesab"
                v-model="SpSelectBalanceSendValues.ConditionsShow"
                name="RadioShowHesab"
                id="AllHesab"
              />
              <label class="form-check-label mr-3 pt-1" for="AllHesab"
                >کلیه حساب‌ها</label
              >
            </div>
            <div
              class="col p-1 text-right form-check d-flex align-items-center"
            >
              <input
                class="form-check-input"
                type="radio"
                value="HesabGardesh"
                v-model="SpSelectBalanceSendValues.ConditionsShow"
                name="RadioShowHesab"
                id="HesabGardesh"
              />
              <label class="form-check-label mr-3 pt-1" for="HesabGardesh"
                >حساب‌های دارای گردش</label
              >
            </div>
            <div
              class="col p-1 text-right form-check d-flex align-items-center"
            >
              <input
                class="form-check-input"
                type="radio"
                value="HesabMande"
                v-model="SpSelectBalanceSendValues.ConditionsShow"
                name="RadioShowHesab"
                id="HesabMande"
              />
              <label class="form-check-label mr-3 pt-1" for="HesabMande"
                >حساب‌های دارای مانده</label
              >
            </div>
          </div>
        </div>
        <!-- شروط محاسبه حساب ها -->
        <div class="col border rounded position-relative p-2 mr-1">
          <div
            class="position-absolute"
            style="top: -10px; right: 10px; background: white; padding: 0 10px"
          >
            شروط محاسبه حساب‌ها
          </div>
          <div class="row">
            <div
              class="col p-1 text-right form-check d-flex align-items-center"
            >
              <input
                class="form-check-input"
                type="radio"
                value="AfterClose"
                v-model="SpSelectBalanceSendValues.ConditionsCalc"
                name="RadioCalcHesab"
                id="AfterClose"
              />
              <label class="form-check-label mr-3 pt-1" for="AfterClose"
                >قبل از بستن حساب‌ها</label
              >
            </div>
            <div
              class="col p-1 text-right form-check d-flex align-items-center"
            >
              <input
                class="form-check-input"
                type="radio"
                value="AllYear"
                v-model="SpSelectBalanceSendValues.ConditionsCalc"
                name="RadioCalcHesab"
                id="AllYear"
              />
              <label class="form-check-label mr-3 pt-1" for="AllYear"
                >کل دوره مالی</label
              >
            </div>
          </div>
        </div>
        <!-- فضای خالی -->
        <div class="col-1 mr-1"></div>
      </div>

      <!-- سطر سوم : شماره سند + تاریخ سند + کد حساب -->
      <div
        class="row mb-2 p-0 d-flex justify-content-between align-items-center"
      >
        <!-- شماره سند -->
        <div class="col border rounded position-relative p-2">
          <div
            class="position-absolute"
            style="top: -10px; right: 10px; background: white; padding: 0 10px"
          >
            شماره سند
          </div>
          <div class="row">
            <div class="col px-1 text-right">
              <input
                type="number"
                class="form-control form-control-sm"
                placeholder="از شماره ..."
                v-model="SpSelectBalanceSendValues.StartNDocNu"
                v-bind:disabled="
                  SpSelectBalanceSendValues.StartDate != '' ||
                  SpSelectBalanceSendValues.EndDate != ''
                "
              />
              <label class="text-info p-0 m-0"
                >اولین شماره :
                {{ this.SelectBalance.SpSelectBalanceGuide.MinNDocNu }}</label
              >
            </div>
            <div class="col px-1 text-right">
              <input
                type="number"
                class="form-control form-control-sm"
                placeholder="تا شماره ..."
                v-model="SpSelectBalanceSendValues.EndNDocNu"
                v-bind:disabled="
                  SpSelectBalanceSendValues.StartDate != '' ||
                  SpSelectBalanceSendValues.EndDate != ''
                "
              />
              <label class="text-info p-0 m-0"
                >آخرین شماره :
                {{ this.SelectBalance.SpSelectBalanceGuide.MaxNDocNu }}</label
              >
            </div>
          </div>
        </div>
        <!-- تاریخ سند -->
        <div class="col border rounded position-relative p-2 mr-1">
          <div
            class="position-absolute"
            style="top: -10px; right: 10px; background: white; padding: 0 10px"
          >
            تاریخ سند
          </div>
          <div class="row">
            <div class="col px-1 text-right">
              <date-picker
                color="#7E489C"
                input-class="form-control form-control-sm rounded-0"
                display-format="jYYYY/jMM/jDD"
                placeholder="از تاریخ ..."
                v-model="SpSelectBalanceSendValues.StartDate"
                v-bind:max="SpSelectBalanceSendValues.EndDate"
                v-bind:initial-value="SpSelectBalanceSendValues.YearAcitve + '/01/01'"
                view="month"
                clearable
                v-bind:disabled="
                  parseInt(SpSelectBalanceSendValues.StartNDocNu) > 0 ||
                  parseInt(SpSelectBalanceSendValues.EndNDocNu) > 0
                "
              ></date-picker>
              <label class="text-info p-0 m-0"
                >اولین تاریخ :
                {{ this.SelectBalance.SpSelectBalanceGuide.MinSDate }}</label
              >
            </div>
            <div class="col px-1 text-right">
              <date-picker
                color="#7E489C"
                input-class="form-control form-control-sm rounded-0"
                display-format="jYYYY/jMM/jDD"
                placeholder="تا تاریخ ..."
                v-model="SpSelectBalanceSendValues.EndDate"
                v-bind:min="SpSelectBalanceSendValues.StartDate"
                v-bind:initial-value="SpSelectBalanceSendValues.YearAcitve + '/01/01'"
                view="month"
                clearable
                v-bind:disabled="
                  parseInt(SpSelectBalanceSendValues.StartNDocNu) > 0 ||
                  parseInt(SpSelectBalanceSendValues.EndNDocNu) > 0
                "
              ></date-picker>
              <label class="text-info p-0 m-0"
                >آخرین تاریخ :
                {{ this.SelectBalance.SpSelectBalanceGuide.MaxSDate }}</label
              >
            </div>
          </div>
        </div>
        <!-- کد حساب -->
        <div class="col border rounded position-relative p-2 mr-1">
          <div
            class="position-absolute"
            style="top: -10px; right: 10px; background: white; padding: 0 10px"
          >
            کد حساب
          </div>
          <div class="row">
            <div tabindex="0" class="col px-1 text-right">
              <AccCode
                v-bind:objName="'ShowAccCodeStart'"
                v-bind:bgColor="'bg-secondary'"
                v-bind:textColor="'text-info'"
                v-bind:setPlaceHolder="'... از کد حساب'"
                v-bind:levelNumber="parseInt(SpSelectBalanceSendValues.DaftarType)"
                v-on:SelectNAccCode="setNAccCodeStart"
              ></AccCode>
            </div>
            <div class="col px-1 text-right">
              <AccCode
                v-bind:objName="'ShowAccCodeEnd'"
                v-bind:bgColor="'bg-secondary'"
                v-bind:textColor="'text-info'"
                v-bind:setPlaceHolder="'... تا کد حساب'"
                v-bind:levelNumber="parseInt(SpSelectBalanceSendValues.DaftarType)"
                v-on:SelectNAccCode="setNAccCodeEnd"
              ></AccCode>
            </div>
          </div>
        </div>
        <!-- دکمه جستجو -->
        <div class="col-1 mr-1 p-0">
          <a
            class="
              btn btn-secondary btn-sm btn-floating
              p-0
              m-0
              d-flex
              justify-content-around
              align-items-center
            "
            title="جستجو"
            style="width: 100%; height: 40px"
            v-on:click="getSelectBalanceData()"
          >
            جستجو
            <i class="fas fa-search fa-2x text-white"></i>
          </a>
        </div>
      </div>
    </div>
    <!-- جدول گزارش ترازنامه -->
    <div class="table-responsive">
      <table
        class="
          table table-bordered table-sm
          text-center
          position-relative
          table-font-size
        "
      >
        <thead style="background-color: #f7f7f7">
          <td colspan="9" class="position-relative">
            تعداد سطرهای گزارش : {{ getSelectBalance.length }} مورد
            <!-- انتقال به سطر جمع -->
            <a
              v-on:click="scrollTable('SpSelectBalanceSum')"
              title="مشاهده سطر جمع"
              class="position-absolute"
              style="top: 24%; right: 7px"
            >
              <i
                class="far fa-arrow-alt-circle-down fa-1x-half text-secondary"
              ></i>
            </a>
          </td>
        </thead>
        <!-- سربرگ جدول -->
        <thead class="text-light bg-secondary">
          <td>ردیف</td>
          <td>کد حساب</td>
          <td>عنوان حساب</td>
          <td>بدهکار اول دوره</td>
          <td>بستانکار اول دوره</td>
          <td>بدهکار طی دوره</td>
          <td>بستانکار طی دوره</td>
          <td>بدهکار پایان دوره</td>
          <td>بستانکار پایان دوره</td>
        </thead>
        <!-- بدنه جدول -->
        <tbody>
          <template v-for="(row, index) in getSelectBalance">
            <tr :key="row.NAccCode" v-bind:id="row.NAccCode">
              <!-- ردیف -->
              <td
                style="
                  max-width: 50px;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                "
              >
                {{ index + 1 }}
              </td>
              <!-- کد حساب -->
              <td
                style="
                  max-width: 120px;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                "
              >
                {{ row.NAccCode }}
              </td>
              <!-- عنوان حساب -->
              <td
                style="
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                "
              >
                {{ row.SAccCode }}
              </td>
              <!-- بدهکار اول دوره -->
              <td
                style="
                  max-width: 120px;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                "
              >
                {{ row.NDebit | numFormat }}
              </td>
              <!-- بستانکار اول دوره -->
              <td
                style="
                  max-width: 120px;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                "
              >
                {{ row.NCredit | numFormat }}
              </td>
              <!-- بدهکار طی دوره -->
              <td
                style="
                  max-width: 120px;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                "
              >
                {{ row.NDebit1 | numFormat }}
              </td>
              <!-- بستانکار طی دوره -->
              <td
                style="
                  text-align: right !important;
                  padding-right: 5px !important;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                  max-width: 250px;
                "
              >
                {{ row.NCredit1 | numFormat }}
              </td>
              <!-- بدهکار پایان دوره -->
              <td
                style="
                  max-width: 120px;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                "
              >
                {{ row.NDebit2 | numFormat }}
              </td>
              <!-- بستانکار پایان دوره -->
              <td
                style="
                  max-width: 120px;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                "
              >
                {{ row.NCredit2 | numFormat }}
              </td>
            </tr>
          </template>
        </tbody>
        <!-- پابرگ جدول -->
        <tfoot class="text-light bg-secondary" id="SpSelectBalanceSum">
          <!-- <td>{{ this.SelectBalance.SpSelectBalanceSum.NAccCode }}</td> -->
          <td colspan="3" class="position-relative">
            {{ this.SelectBalance.SpSelectBalanceSum.SDesc }}
            <!-- انتقال به سطر سربرگ -->
            <a
              v-on:click="scrollTable('HeadSpSelectBalance')"
              title="مشاهده سطر سربرگ"
              class="position-absolute"
              style="top: 18%; right: 10px"
            >
              <i class="far fa-arrow-alt-circle-up fa-1x-half text-light"></i>
            </a>
          </td>
          <td>
            {{ this.SelectBalance.SpSelectBalanceSum.NDebit | numFormat }}
          </td>
          <td>
            {{ this.SelectBalance.SpSelectBalanceSum.NCredit | numFormat }}
          </td>
          <td>
            {{ this.SelectBalance.SpSelectBalanceSum.NDebit1 | numFormat }}
          </td>
          <td>
            {{ this.SelectBalance.SpSelectBalanceSum.NCredit1 | numFormat }}
          </td>
          <td>
            {{ this.SelectBalance.SpSelectBalanceSum.NDebit2 | numFormat }}
          </td>
          <td>
            {{ this.SelectBalance.SpSelectBalanceSum.NCredit2 | numFormat }}
          </td>
        </tfoot>
      </table>
    </div>
  </div>
</template>

<script>
import AccCode from "../PublicComponents/AccCode/AccCode.vue";

export default {
  components: {
    AccCode,
  },
  data() {
    return {
      // گزارش ترازنامه
      SelectBalance: {
        // سطرهای گزارش ترازنامه
        SpSelectBalanceRows: [
          {
            NAccCode: 0, // کد حساب
            SAccCode: "", // عنوان حساب
            NDebit: 0, // بدهکار اول دوره
            NCredit: 0, // بستانکار اول دوره
            NDebit1: 0, // بدهکار طی دوره
            NCredit1: 0, // بستانکار طی دوره
            NDebit2: 0, // بدهکار پایان دوره
            NCredit2: 0, // بستانکار پایان دوره
            NDebitState: 0, // وضعیت بدهکار
            NCreditState: 0, // وضعیت بستانکار
          },
        ],
        // جمع کل انتهای گزارش ترازنامه
        SpSelectBalanceSum: {
          NAccCode: 0, // شماره ردیف - تعداد سطرهای گزارش
          SDesc: "", // عنوان سطر : جمع کل
          NDebit: 0, // بدهکار اول دوره
          NCredit: 0, // بستانکار اول دوره
          NDebit1: 0, // بدهکار طی دوره
          NCredit1: 0, // بستانکار طی دوره
          NDebit2: 0, // بدهکار پایان دوره
          NCredit2: 0, // بستانکار پایان دوره
          NDebitState: 0, // وضعیت بدهکار
          NCreditState: 0, // وضعیت بستانکار
        },
        // مقادیر راهنمای کاربر
        SpSelectBalanceGuide: {
          MinNDocNu: 0, // اولین شماره سند
          MaxNDocNu: 0, // آخرین شماره سند
          MinSDate: "", // اولین تاریخ
          MaxSDate: "", // آخرین تاریخ
        },
      },
      // مقادیر ارسال به گزارش ترازنامه
      SpSelectBalanceSendValues: {
        DaftarType: 3, // نوع دفتر کل: 3 معین1: 5 معین2: 7 تفصیلی: 11
        ConditionType: false, // فقط سطح مشخص شده
        Organization: 0, // سازمان
        ConditionsShow: "AllHesab", // شروط نمایش
        ConditionsCalc: "AfterClose", // شروط محاسبه
        StartNDocNu: "", // از شماره سند
        EndNDocNu: "", // تا شماره سند
        StartNId: "", // از کد حساب
        EndNId: "", // تا کد حساب
        StartDate: "", // از تاریخ
        EndDate: "", // تا تاریخ
        YearAcitve: this.$store.getters.getYearActive, // سال مالی جاری
      },
    };
  },
  created() {
    // this.getSelectBalanceData();
  },
  computed: {
    // دریافت اطلاعات لیست گزارش ترازنامه از مخزن
    getSelectBalance() {
      // دریافت لیست گزارش ترازنامه از مخزن اصلی
      this.SelectBalance = this.$store.getters.getSelectBalance;
      return this.SelectBalance.SpSelectBalanceRows;
    },
    // دریافت لیست سازمان ها
    getTbBaseOrgData() {
      return this.$store.getters.getTbBaseOrgData;
    },
  },
  methods: {
    // جابجایی به سطر جمع یا سربرگ
    scrollTable(objectID) {
      $("#" + objectID).scrollintoview({
        duration: 500,
      });
    },
    // دریافت گزارش ترازنامه از سرور
    async getSelectBalanceData() {
      // کنترل صحت اطلاعات درج شد

      // آیا برای از شماره سند مقداری ثبت شده است
      if (
        this.SpSelectBalanceSendValues.StartNDocNu != "" &&
        parseInt(this.SpSelectBalanceSendValues.StartNDocNu) > 0
      ) {
        // تخلیه تاریخ شروع و پایان
        this.SpSelectBalanceSendValues.StartDate = "";
        this.SpSelectBalanceSendValues.EndDate = "";
        if (
          this.SpSelectBalanceSendValues.EndNDocNu != "" &&
          parseInt(this.SpSelectBalanceSendValues.EndNDocNu) > 0
        ) {
          if(parseInt(this.SpSelectBalanceSendValues.StartNDocNu) > parseInt(this.SpSelectBalanceSendValues.EndNDocNu)){
            // نمایش پیام از شماره سند نباید بزرگتر از تا شماره سند باشد
            swal({
              title: "مقدار شماره سند صحیح نمی باشد !",
              text: "مقدار ( از شماره سند ... ) نباید بزرگتر از ( تا شماره سند ... ) باشد .",
              icon: "warning", // success, warning, error, info
              buttons: {
                cancel: "متوجه شدم",
              },
            });
            return false;
          }
        } else {
          // نمایش پیام درج تا شماره سند الزامی است
          swal({
            title: "مقدار شماره سند صحیح نمی باشد !",
            text: "درج ( تا شماره سند ... ) الزامی است .",
            icon: "warning", // success, warning, error, info
            buttons: {
              cancel: "متوجه شدم",
            },
          });
          return false;
        }
      }
      // آیا برای از تاریخ سند مقداری ثبت شده است
      if (this.SpSelectBalanceSendValues.StartDate != "") {
        // تخلیه شماره شروع و پایان
        this.SpSelectBalanceSendValues.StartNDocNu = "";
        this.SpSelectBalanceSendValues.EndNDocNu = "";
        if (this.SpSelectBalanceSendValues.EndDate != "") {
          if (this.SpSelectBalanceSendValues.StartDate.substring(0,4) != this.SpSelectBalanceSendValues.YearAcitve.toString() || this.SpSelectBalanceSendValues.EndDate.substring(0,4) != this.SpSelectBalanceSendValues.YearAcitve.toString()) {
            // نمایش پیام تاریخ درج شده با سال جاری مطابقت ندارد
            swal({
              title: "مقدار تاریخ سند صحیح نمی باشد !",
              text: "تاریخ درج شده با سال مالی مطابقت ندارد !",
              icon: "warning", // success, warning, error, info
              buttons: {
                cancel: "متوجه شدم",
              },
            });
            return false;
          }
          if(parseInt(this.SpSelectBalanceSendValues.StartDate.replace(/\//g,'')) > parseInt(this.SpSelectBalanceSendValues.EndDate.replace(/\//g,''))) {
            // نمایش پیام از تاریخ ... نباید بزرگتر از تا تاریخ ... باشد
            swal({
              title: "مقدار تاریخ سند صحیح نمی باشد !",
              text: "مقدار ( از تاریخ ... ) نباید بزرگتر از ( تا تاریخ ... ) باشد .",
              icon: "warning", // success, warning, error, info
              buttons: {
                cancel: "متوجه شدم",
              },
            });
            return false;
          }
        } else {
          // نمایش پیام درج تا تاریخ الزامی است
          swal({
            title: "مقدار تاریخ سند صحیح نمی باشد !",
            text: "درج ( تا تاریخ ... ) الزامی است .",
            icon: "warning", // success, warning, error, info
            buttons: {
              cancel: "متوجه شدم",
            },
          });
          return false;
        }
      }

      // آیا برای از کد حساب تا کد حساب مقداری درج شده است
      if(this.SpSelectBalanceSendValues.StartNId != "" && parseInt(this.SpSelectBalanceSendValues.StartNId) > 0){
        if (this.SpSelectBalanceSendValues.EndNId != "" && parseInt(this.SpSelectBalanceSendValues.EndNId) > 0){
          if (parseInt(this.SpSelectBalanceSendValues.StartNId) > parseInt(this.SpSelectBalanceSendValues.EndNId)){
            // نمایش پیام از کد حساب نباید بزرگتر از تا کد حساب باشد
            swal({
              title: "مقدار کد حساب صحیح نمی باشد !",
              text: "مقدار ( از کد حساب ... ) نباید بزرگتر از ( تا کد حساب ... ) باشد .",
              icon: "warning", // success, warning, error, info
              buttons: {
                cancel: "متوجه شدم",
              },
            });
            return false;
          }
        } else {
          // نمایش پیام درج تا کد حساب الزامی است
          swal({
            title: "مقدار کد حساب صحیح نمی باشد !",
            text: "درج ( تا کد حساب ... ) الزامی است .",
            icon: "warning", // success, warning, error, info
            buttons: {
              cancel: "متوجه شدم",
            },
          });
          return false;
        }
      }

      // نمایش لطفا صبر نمایید
      this.$store.dispatch("pleaseWait", {
        notText: "دریافت گزارش ترازنامه از سرور",
      });

      // خالی کردن مغادیر قبلی
      this.SelectBalance.SpSelectBalanceRows = {}; // خالی کردن سطرهای گزارش
      this.SelectBalance.SpSelectBalanceSum = {}; // خالی کردن سطر جمع انتهایی
      // دریافت مقادیر جدید از سرور
      let token = await this.$store.getters.getUserData.token;
      await this.$store.dispatch("getSelectBalanceFromServer", {
        SpSelectBalanceSendValues: this.SpSelectBalanceSendValues,
        token: token,
      });

      // مخفی کردن کادر لطفا صبر نمایید
      this.$store.dispatch("pleaseWait", { stop: true });
    },
    // دریافت مقدار از کامپاننت شروع کد حساب
    setNAccCodeStart(event) {
      this.SpSelectBalanceSendValues.StartNId = event;
    },
    // دریافت مقدار از کامپاننت پایان کد حساب
    setNAccCodeEnd(event) {
      this.SpSelectBalanceSendValues.EndNId = event;
    },
  },
};
</script>

<style scoped>
.vpd-input-group .vpd-clear-btn {
  line-height: 26px;
  width: 26px;
}

.vpd-input-group .vpd-clear-btn:hover {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/pages/AdminPanel/Components/ReportTarazname/ReportTarazname.vue